import CampaignSummaryPanel from './campaignSummaryPanel.container';

export default CampaignSummaryPanel;